import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["fileInput", "hiddenFormSubmit"];

  // We use a hidden submit button to submit the form. Just doing form.submit() caused trouble with logouts being triggered.
  submitUploadForm(event) {
    this.hiddenFormSubmitTarget.click()
    // Clear the input so onchange can be triggered again
    event.target.value = '';
  }

  prepareUpload(event) {
    var fileType = this.fileInputTarget.files[0].type;
    // The form is usually not a remote form. However, when uploading from a bank account row and performing immediate matching
    // it is. handle-unmatched-bank-row-controller.js makes that switch. Also, whenever we upload a csv, we always use a remote form.
    if(["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].includes(fileType)) {
      // Make the form a remote form before uploading, because we want to handle the response with js
      this.element.dataset.remote = 'true'
      this.submitUploadForm(event);
    } else if(fileType == "application/pdf") {
      // We just submit the form
      this.submitUploadForm(event);
    } else if(fileType == "") {
      // This is for SIE files currently, since they for some reason don't have a fileType.
      this.submitUploadForm(event);
    } else if(fileType.match(/image/)) {
      // The uploaded should be an image in this case, since we only allow csv, pdf or image
      ImageTools.resize(this.fileInputTarget.files[0], { width: 1500, height: 1500 }, function(blob, didItResize) { 
        const myFile = new File([blob], 'CRes-' + this.fileInputTarget.files[0].name, { type: 'image/jpeg', lastModified: new Date() });
        const dataTransfer = new DataTransfer(); 
        dataTransfer.items.add(myFile); 
        this.fileInputTarget.files = dataTransfer.files; 
        this.submitUploadForm(event);
      }.bind(this));
    } else {
      // Zip-files and other unknowns, we just submit and let IncomingAccountingData handle them.
      this.submitUploadForm(event);
    }
  }
}